import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=a59d43ba&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=a59d43ba&prod&scoped=true&lang=css&"
import style1 from "./Register.vue?vue&type=style&index=1&id=a59d43ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59d43ba",
  null
  
)

export default component.exports